import { formatDate } from "@telerik/kendo-intl";
import React, { useContext } from "react";
import { ReactSVG } from "react-svg";
import AppContext from "../../../AppContext";
import Details from "../Details";
import AssetMap from "../AssetMap";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import KendoLoadingPanel from "../../KendoLoadingPanel";

const boolColumn = (props) => {
  return (
    <div>
      {props.dataItem.active === true ? (
        <div className=" text-green-600 py-2 px-4">Active</div>
      ) : (
        <div className=" text-orange-600 py-2">Inactive</div>
      )}
    </div>
  );
};

const actionColumn = (props, onChildAssetView) => {
  return (
    <td>
      <button
        onClick={() => onChildAssetView(props.dataItem)}
        className="px-2 py-1 text-xs text-white bg-blue-500 rounded"
      >
        View
      </button>
    </td>
  );
};

const ParentView = ({
  goBackClick,
  assetData,
  t,
  expanded,
  detailsRef,
  momentData,
  mode,
  autoCenter,
  setAutoCenter,
  mapRef,
  childAssets,
  onChildAssetView,
}) => {
  const { getTimeZoneDateTime, playbackMode, darkMode, config } =
    useContext(AppContext);
  const columns = [
    {
      field: "name",
      title: "Asset Name",
    },
    {
      field: "active",
      title: "Status",
      cell: boolColumn,
    },
    {
      field: "id",
      title: "Actions",
      width: 150,
      cell: (e) => actionColumn(e, onChildAssetView),
    },
  ];
  return (
    <div className="h-full w-full">
      <div className="flex flex-col gap-1 h-full w-full">
        <div className="h-1/2 flex gap-4">
          <div className="w-1/2 flex flex-col gap-2">
            <div className="flex px-4 pl-1 pb-2 dark:text-white text-black justify-between">
              <div className="flex gap-3 items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2.0"
                  stroke="currentColor"
                  className="h-4 lg:h-7 w-4 lg:w-7"
                  onClick={goBackClick}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                  />
                </svg>
                <label className="md:text-xs text-xxs lg:text-lg font-semibold">
                  {assetData?.name}
                </label>
              </div>
              {/* <div className="flex items-center dark:text-stone-300 text-black md:text-xxs text-xxxs">
              
                
              </div> */}
            </div>
            <Details
              assetData={assetData}
              detailsPreference={config}
              expanded={expanded}
              momentData={momentData}
              playBackMode={playbackMode}
              currentPlayTime={null}
              ref={detailsRef}
              assetConfig={null}
            />
          </div>
          <div className="w-1/2 flex flex-col gap-2">
            <div className="flex px-4 pb-1 dark:text-stone-300 text-black justify-between items-center">
              <div>
                <label className="text-xs font-medium w-56 mr-2">
                  {t("assetDetails.map.headerText")}
                </label>
              </div>
            </div>
            {assetData && (
              <AssetMap
                mode={{ map: 6 }}
                expanded={expanded}
                assetData={assetData}
                detailsPreference={config}
                playBackMode={playbackMode}
                momentData={momentData}
                setAutoCenter={setAutoCenter}
                autoCenter={autoCenter}
                ref={mapRef}
              />
            )}
          </div>
        </div>
        <div className="h-1/2 flex flex-col grow-0 shrink-0 p-1">
          <div className="flex md:px-4 px-1 py-2 dark:text-stone-300 text-black justify-between items-center gap-1">
            <div className="flex gap-3 items-center">
              <label className="md:text-xs text-xxs font-medium w-fit">
                Related Assets
              </label>
              {/* {playbackMode !== 200 && (
                <TimeModeSelector
                  timeModes={timeModes}
                  selectedMode={mode.table}
                  onChange={(newMode) =>
                    setMode((pre) => ({ ...pre, table: newMode }))
                  }
                  disabled={playbackMode === 200}
                />
              )} */}
            </div>
            {/* <ExpandButton
              buttonType={"table"}
              expanded={expanded}
              setExpanded={setExpanded}
              darkMode={darkMode}
            /> */}
          </div>
          <div
            className={`${expanded === "table" ? "h-5/6" : "md:h-[87%] h-72"} ${
              darkMode ? "darkGrid" : "lightGrid"
            } overflow-x-auto overflow-y-hidden relative border rounded-2xl border-zinc-800 shadow-md`}
          >
            {/* {loading && <KendoLoadingPanel />} */}
            <Tooltip
              anchorElement="target"
              style={{ backgroundColor: "#434343" }}
              openDelay={100}
            >
              <Grid
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "#181921",
                  borderRadius: "15px",
                  textAlign: "justify",
                  overflow: "auto",
                }}
                data={childAssets}
                scrollable="scrollable"
              >
                {columns.map((column, idx) => (
                  <GridColumn
                    key={idx}
                    field={column.field}
                    title={column.title}
                    filterable={column.filterable}
                    cell={column.cell}
                    width={column.width || "auto"}
                    filter={column.filter}
                    //   columnMenu={
                    //     column.filterable
                    //       ? (props) =>
                    //           ColumnMenuFilter({
                    //             ...props,
                    //             type: column.columnMenuType,
                    //             data: column.columnMenuData,
                    //             setFilterData,
                    //             filterData,
                    //           })
                    //       : null
                    //   }
                  />
                ))}
              </Grid>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParentView;
